<template>
    <div>
        <page-header :title="$t('pages.locker.get_aform.upcoming_live_events.title')" :use-title-as-document-title="false"></page-header>
        <div class="row mb-3" v-if="liveStreamAnnouncements.length">
            <div class="col-md-4" v-for="announcement in liveStreamAnnouncements" >
                <div class="card rounded shadow-sm">
                    <div class="card-body bg-light">
                        <h5>
                                <span class="font-weight-bold">
                                    {{ announcement.title[$i18n.locale] }}
                                </span>
                        </h5>
                        <i class="mdi mdi-calendar"></i>
                        <span class="font-weight-lighter">
                                {{ $date(announcement.starts_at).format('DD.MM.YYYY HH:mm') }}
                            </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-else>
            <div class="col-md-12">
                <div class="alert alert-secondary border-dark shadow-sm">
                    {{ $t('pages.locker.get_aform.upcoming_live_events.none') }}
                </div>
            </div>
        </div>


        <page-header :title="$t('pages.locker.get_aform.newest_trainings.title')"  :use-title-as-document-title="false"></page-header>
        <div class="row">
            <div class="col-md-4  grid-margin" v-for="video in latest_videos" :key="video.id">
                <gym-video-card-new :video="video" :page-link-enabled="true"/>
            </div>
        </div>
    </div>
</template>

<script>
import LockerRoomRepository from "../../../repositories/LockerRoom/LockerRoomRepository";
import GymVideoCardNew from "../../Gym/Includes/GymVideoCardNew";
import PageHeader from "../../Includes/PageHeader";
import LiveStreamAnnouncementRepository from "../../../repositories/Livestream/LiveStreamAnnouncementRepository";

export default {
    name: "GetAform",
    components: {PageHeader, GymVideoCardNew},
    data: () => ({
        latest_videos: [],
        upcoming_live_trainings: [],

        liveStreamAnnouncements: []
    }),
    mounted() {
        LockerRoomRepository
            .getAFORM()
            .then((res) => {
                this.latest_videos = res.data.latest_videos;
                this.upcoming_live_trainings = res.data.upcoming_live_trainings;
            });

        LiveStreamAnnouncementRepository
            .getUpcoming()
            .then((res) => this.liveStreamAnnouncements = res.data);
    }
}
</script>

<style scoped>

</style>
